export default "__VITE_ASSET__CuDTPH8w__"